import React, { useEffect } from 'react';

import BackgroundImage from '@/operator/components/general/BackgroundImage';
import { StyledTwoScreensWrapper } from '@/operator/components/modules/AuthPage/Styles';
import { MessageWithTip } from '@/operator/components/modules/AuthPage/setup/MessageWithTip';
import { CircularProgress } from '@mui/material';
// import { GetStaticPathsContext } from 'next';
import { useTranslation } from 'react-i18next';
// import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
// import { useRouter } from 'next/navigation';
import { useOrgNavigate } from "app/routes/useOrgNavigate";

import { useAppContext } from '../../../context/AppContext';
import useOnHandlePageReload from '@/operator/hooks/useOnHandlePageReload';
import useOnLeavingPageConfirmation from '@/operator/hooks/useOnLeavingPageConfirmation';
import image from '@/operator/public/assets/images/background/you_made_it_img.svg';
import { appRoutes } from '@/routes/constants';
import { useSubdomain } from 'hooks/useSubdomain';
import { getOperatorTenantUrl } from "@/operator/utils/env/urlStrings";

const tenantURLDomain = process.env.NEXT_PUBLIC_TENANT_URL_DOMAIN;

const DonePage = (): JSX.Element => {
    // const { push } = useRouter();
    const navigate = useOrgNavigate();
    const { subdomain } = useSubdomain();

    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    const { t } = useTranslation();

    useOnLeavingPageConfirmation(
        t('General.OnLeavingPageConfirmation.GeneralMessage'),
        { disableBeforeUnloadListener: true },
    );
    useOnHandlePageReload(() => navigate(appRoutes.AUTH_SETUP_BUILD));

    const { vanityURL } = useAppContext();

    useEffect(() => {
        if (!vanityURL) {
            return navigate(appRoutes.AUTH_SETUP_BUILD);
        }
        const redirectTo = getOperatorTenantUrl(vanityURL);
        const pushTimeout = setTimeout(() => {
            window.location.href = redirectTo;
        }, 5000);
        return () => {
            clearTimeout(pushTimeout);
        };
    }, []);

    return (
        <StyledTwoScreensWrapper>
            <MessageWithTip
                Icon={CircularProgress}
                headline={t('Auth.Setup.Done.Content.Header')}
                description={t('Auth.Setup.Done.Content.Description')}
            />

            <BackgroundImage src={image} />
        </StyledTwoScreensWrapper>
    );
};

// export async function getStaticProps(context: GetStaticPathsContext) {
//     // extract the locale identifier from the URL in the future
//     // at this point default one will serve is
//     const { defaultLocale } = context;

//     return {
//         props: {
//             // pass the translation props to the component
//             ...(await serverSideTranslations(defaultLocale as string)),
//         },
//     };
// }

export default DonePage;
